import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Observable, finalize, shareReplay } from 'rxjs';

const inFlightGetRequests = new Map<string, Observable<HttpEvent<unknown>>>();

function createRequestKey(req: HttpRequest<unknown>): string {
  return `${req.method} ${req.urlWithParams}`;
}

export const inFlightGetInterceptor: HttpInterceptorFn = (req, next: HttpHandlerFn) => {
  if (req.method !== 'GET') {
    return next(req);
  }

  const requestKey = createRequestKey(req);
  const existingRequest = inFlightGetRequests.get(requestKey);

  if (existingRequest) {
    console.info('[HTTP][DEDUPED]', {
      method: req.method,
      url: req.urlWithParams,
      requestId: req.headers.get('X-Request-Id') || null
    });
    return existingRequest;
  }

  const sharedRequest$ = next(req).pipe(
    finalize(() => {
      inFlightGetRequests.delete(requestKey);
    }),
    shareReplay({ bufferSize: 1, refCount: true })
  );

  inFlightGetRequests.set(requestKey, sharedRequest$);
  return sharedRequest$;
};
